export default __webpack_public_path__ + "static/media/store.870b4083.png";